import { render } from "./CardProject.vue?vue&type=template&id=6379b44d&scoped=true&ts=true"
import script from "./CardProject.vue?vue&type=script&lang=ts"
export * from "./CardProject.vue?vue&type=script&lang=ts"

import "./CardProject.vue?vue&type=style&index=0&id=6379b44d&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6379b44d"]])

export default __exports__